import React from 'react';
import { Modal } from '@appkit4/react-components/modal';
import { Loading } from '@appkit4/react-components';
import './duplicateModal.scss';

interface DuplicateModalProps {
    visible: boolean;
    title?: string;
    onCancel?: () => void;
    modalStyle?: React.CSSProperties;
}

const DuplicateModal: React.FC<DuplicateModalProps> = ({
    visible,
    title = 'Duplicating file',
    onCancel,
    modalStyle,
}) => {
    return (
        <Modal visible={visible} title={title} onCancel={onCancel} modalStyle={modalStyle} maskCloseable={false}>
            <div className="duplicating-loader-wrapper">
                <div className="duplicating-content">
                    <div className="duplicating-text">
                        <div className="ap-typography-heading-s">This may take a few seconds</div>
                    </div>
                    <div className="duplicating-spinner">
                        <Loading loadingType="circular" indeterminate={true} compact={false} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DuplicateModal;
export { DuplicateModal };
